export const m = {
	header: {
		home: '首页',
		company: '旗下游戏',
		corporate: '公司介绍',
		products: '人才招聘',
		joinus: '商务合作'
	},
	home: {
		moregame: '更多游戏',
		gameintro: '企业资讯',
		companyintro: '公司简介',
		moredetail: '更多详情',
		aboutcompany: '苏州爱洛克信息技术有限公司总部位于苏州市工业园区，分别在上海、海口、香港、台北、首尔和新加坡设立有分支机构。创始团队均来自Activision Blizzard等知名游戏公司，平均从业10年以上，有丰富的AAA级游戏制作经验和发行经验。',
		sz: '苏州-总部',
		tw: '台北',
		xg: '香港',
		kr: '首尔',
		sh: '上海',
		hn: '海南',
		xjp: '新加坡',
		welcome: '欢迎优秀的你加入',
		joinus: '加入我们',
		aboutus: '创始团队均来自Activision Blizzard等知名游戏公司，平均从业10年以上，有丰富的AAA级游戏制作经验和发行经验。团队曾在中国及全球app store, Googleplay商店成功发行过多款Top 10游戏。'
	},
	company: {
		about: '公司介绍',
		content1: '苏州爱洛克信息技术有限公司总部位于苏州市工业园区，分别在上海、海口、香港、台北、首尔和新加坡设立有分支机构。创始团队均来自Activision Blizzard等知名游戏公司，平均从业10年以上，有丰富的AAA级游戏制作经验和发行经验。团队曾在中国及全球AppStore, GooglePlay应用商店成功发行过多款Top 10游戏。2015年，公司获得国内知名投资机构投资，确立以 MoreFun Game 作为全球游戏发行品牌，连续在中国港澳台、东南亚等地区发行多款优质游戏，成为该区域的领军新锐，步入快速发展期。',
		content2: '团队曾在中国及全球AppStore, GooglePlay应用商店成功发行过多款Top 10游戏。2015年，公司获得国内知名投资机构投资，确立以 MoreFun Game 作为全球游戏发行品牌，连续在中国港澳台、东南亚等地区发行多款优质游戏，成为该区域的领军新锐，步入快速发展期。',
		head: '公司总部',
		issuing: '主要发行区域',
		history: '公司历程',
		game1: '获得首轮投资 正式开始海外手游发行业务',
		game2: '获得凯撒文化创投基金 3000万投资',
		game3: '获颁授苏州 工业园区瞪羚培育企业',
		game4: '获颁授江苏省 隐形小巨人企业',
		game5: '韩国子公司 IClockwork Inc.正式成立',
		game6: '获颁授国家文化出口 重点企业资质',
		game7: '获得江苏省 重点文化科技企业 ',
		game8: '获得江苏省 重点软件培育企业',
		game9: '新加坡子公司 ICLOCKWORK PTE.LTD.正式成立',
		team: '团队建设',
		pic1: '年礼',
		pic2: '年会节目',
		pic3: '桌游社活动',
		pic4: '7周年庆',
		pic5: '观影券',
		pic6: '公司场景',
		pic7: '旅游',
		pic8: '合照',
		pic9: '英语课堂',
		sz: '苏州',
		xg: '香港',
		tb: '台北',
		hg: '韩国',
		dny: '东南亚',
		bm: '北美'
	},
	culture: {
		cu: '企业文化',
		cv: '核心理念',
		td: '人才发展',
		we: '办公环境',
		ea: '员工活动',
		vs: '愿景',
		ms: '使命'
	},
	products: {
		gm: '精品游戏',
		oc: '进入官网'
	},
	joinus: {
		ph: '联系方式',
		em: '企业邮箱',
		ad: '国内地址',
		tips: '简历投递方式： “姓名+投递岗位” 命名的个人简历投递到邮箱',
		require: '岗位要求：',
		responsibility: '岗位职责：',
		all: '所有'
	},
	footer: {
		companyInfo: '公司介绍',
		itesGame: '旗下游戏',
		peopleJob: '人才招聘',
		contactUs: '联系我们',
		legalNotice: '法律声明'
	}

}